class FacetFiltersForm extends HTMLElement {
	constructor() {
		super();
		this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

		this.debouncedOnSubmit = debounce((event) => {
			this.onSubmitHandler(event);
		}, 500);

		const facetForms = this.querySelectorAll("form");
		facetForms.forEach((facetForm) => {
			facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
			facetForm.addEventListener("change", this.debouncedOnSubmit.bind(this));
		});

		const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
		if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);

		const facetButton = this.querySelector(".facets__button-show");
		if (facetButton) facetButton.setAttribute("aria-expanded", "false");

		const sortSelect = this.querySelector("#SortBy");
		if (sortSelect && sortSelect.dataset.sortOpenBound !== "true") {
			sortSelect.dataset.sortOpenBound = "true";
			sortSelect.addEventListener("click", () => sortSelect.classList.toggle("open"));
			sortSelect.addEventListener("blur", () => sortSelect.classList.remove("open"));
		}

		const checkboxes = document.querySelectorAll(
			'#FacetFiltersFormMobile .js-filter input[type="checkbox"]'
		);
		const removebtn = document.querySelector(
			"#FacetFiltersFormMobile .facets-tag-wrapper"
		);
		const allChecked = Array.from(checkboxes).some(
			(checkbox) => checkbox.checked
		);

		if (removebtn) {
			if (allChecked) {
				removebtn.classList.remove("active");
			} else {
				removebtn.classList.add("active");
			}
		}
	}

	static setListeners() {
		const onHistoryChange = (event) => {
			const searchParams = event.state
				? event.state.searchParams
				: FacetFiltersForm.searchParamsInitial;
			if (searchParams === FacetFiltersForm.searchParamsPrev) return;
			FacetFiltersForm.renderPage(searchParams, null, false);
		};
		window.addEventListener("popstate", onHistoryChange);

		if (FacetFiltersForm.delegatedChangeListenerAdded) return;

		document.addEventListener(
			"change",
			(event) => {
				const target = event.target;
				if (
					!target ||
					!target.closest ||
					!target.matches ||
					!target.matches("input, select")
				)
					return;

				const form = target.closest(
					"#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm, #FacetSortDrawerForm"
				);
				if (!form) return;

				const host = form.closest("facet-filters-form");
				if (host && typeof host.onSubmitHandler === "function") {
					host.onSubmitHandler(event);
					return;
				}

				FacetFiltersForm.onFilterFormChange(event, form);
			},
			true
		);

		document.addEventListener(
			"submit",
			(event) => {
				const target = event.target;
				if (!target || !target.closest) return;

				const form = target.closest(
					"#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm, #FacetSortDrawerForm"
				);
				if (!form) return;

				FacetFiltersForm.onFilterFormChange(event, form);
			},
			true
		);

			document.addEventListener(
				"click",
				(event) => {
					const target = event.target;
					if (!target || !target.closest) return;

					const filterToggle = target.closest(
						".facets__button-show, .button--unstyled.facets__button-show"
					);
					if (filterToggle && FacetFiltersForm.isMobileFilterLayout()) {
						event.preventDefault();
						event.stopPropagation();
						if (typeof event.stopImmediatePropagation === "function") {
							event.stopImmediatePropagation();
						}
						FacetFiltersForm.toggleCollectionFilterDrawer(filterToggle);
						return;
					}

					const filterClose = target.closest(".facets-modal__close");
					if (filterClose && FacetFiltersForm.isMobileFilterLayout()) {
						event.preventDefault();
						event.stopPropagation();
						if (typeof event.stopImmediatePropagation === "function") {
							event.stopImmediatePropagation();
						}
						FacetFiltersForm.closeCollectionFilterDrawer(filterClose);
						return;
					}

					if (
						FacetFiltersForm.isMobileFilterLayout() &&
						document.body.classList.contains("collection-filter-open") &&
						!target.closest(".facets__wrapper") &&
						!filterToggle
					) {
						FacetFiltersForm.closeAllCollectionFilterDrawers();
					}

					const link = target.closest("facet-remove a, .js-facet-remove");
					if (!link || !link.href) return;

				event.preventDefault();
				event.stopPropagation();
				if (typeof event.stopImmediatePropagation === "function") {
					event.stopImmediatePropagation();
				}
				FacetFiltersForm.toggleActiveFacets();
				const url =
					link.href.indexOf("?") == -1
						? ""
						: link.href.slice(link.href.indexOf("?") + 1);
				FacetFiltersForm.renderPage(url);
			},
			true
		);

			FacetFiltersForm.delegatedChangeListenerAdded = true;
		}

		static isMobileFilterLayout() {
			return window.matchMedia("(max-width: 989px)").matches;
		}

		static getCollectionFilterWrapper(trigger) {
			const facetsContainer = trigger ? trigger.closest(".facets-container") : null;
			return (
				(facetsContainer && facetsContainer.querySelector(".facets__wrapper")) ||
				document.querySelector(".facets__wrapper")
			);
		}

		static setCollectionFilterButtonsExpanded(expanded) {
			document
				.querySelectorAll(".facets__button-show, .button--unstyled.facets__button-show")
				.forEach((button) => {
					button.setAttribute("aria-expanded", expanded ? "true" : "false");
				});
		}

		static syncCollectionFilterBodyState() {
			const hasOpenDrawer = !!document.querySelector(
				".facets__wrapper.is-collection-filter-open"
			);
			document.body.classList.toggle("collection-filter-open", hasOpenDrawer);
			document.body.classList.toggle("filter-open", hasOpenDrawer);
			document.body.classList.toggle("overflow-hidden", hasOpenDrawer);
		}

		static openCollectionFilterDrawer(trigger) {
			const wrapper = FacetFiltersForm.getCollectionFilterWrapper(trigger);
			if (!wrapper) return;

			document.querySelectorAll(".facets__wrapper").forEach((currentWrapper) => {
				if (currentWrapper === wrapper) return;
				currentWrapper.style.display = "none";
				currentWrapper.classList.remove("is-collection-filter-open");
				const container = currentWrapper.closest(".facets__container");
				if (container) container.classList.remove("active");
			});

			wrapper.style.display = "block";
			wrapper.classList.add("is-collection-filter-open");
			const container = wrapper.closest(".facets__container");
			if (container) container.classList.add("active");
			FacetFiltersForm.setCollectionFilterButtonsExpanded(true);
			FacetFiltersForm.syncCollectionFilterBodyState();
		}

		static closeCollectionFilterDrawer(triggerOrWrapper) {
			const wrapper =
				(triggerOrWrapper &&
					triggerOrWrapper.closest &&
					triggerOrWrapper.closest(".facets__wrapper")) ||
				FacetFiltersForm.getCollectionFilterWrapper(triggerOrWrapper);
			if (!wrapper) return;

			wrapper.style.display = "none";
			wrapper.classList.remove("is-collection-filter-open");
			const container = wrapper.closest(".facets__container");
			if (container) container.classList.remove("active");
			FacetFiltersForm.setCollectionFilterButtonsExpanded(false);
			FacetFiltersForm.syncCollectionFilterBodyState();
		}

		static closeAllCollectionFilterDrawers() {
			document.querySelectorAll(".facets__wrapper").forEach((wrapper) => {
				wrapper.style.display = "none";
				wrapper.classList.remove("is-collection-filter-open");
				const container = wrapper.closest(".facets__container");
				if (container) container.classList.remove("active");
			});
			FacetFiltersForm.setCollectionFilterButtonsExpanded(false);
			FacetFiltersForm.syncCollectionFilterBodyState();
		}

		static toggleCollectionFilterDrawer(trigger) {
			const wrapper = FacetFiltersForm.getCollectionFilterWrapper(trigger);
			if (!wrapper) return;

			if (wrapper.classList.contains("is-collection-filter-open")) {
				FacetFiltersForm.closeCollectionFilterDrawer(wrapper);
				return;
			}

			FacetFiltersForm.openCollectionFilterDrawer(trigger);
		}

		static resetCollectionFilterDrawerState(root = document) {
			const wrappers = root.querySelectorAll
				? root.querySelectorAll(".facets__wrapper")
				: [];

			if (!FacetFiltersForm.isMobileFilterLayout()) {
				wrappers.forEach((wrapper) => {
					wrapper.style.removeProperty("display");
					wrapper.classList.remove("is-collection-filter-open");
					const container = wrapper.closest(".facets__container");
					if (container) container.classList.remove("active");
				});
				FacetFiltersForm.setCollectionFilterButtonsExpanded(false);
				FacetFiltersForm.syncCollectionFilterBodyState();
				return;
			}

			wrappers.forEach((wrapper) => {
				if (wrapper.classList.contains("is-collection-filter-open")) {
					wrapper.style.display = "block";
					return;
				}

				wrapper.style.display = "none";
				const container = wrapper.closest(".facets__container");
				if (container) container.classList.remove("active");
			});
			FacetFiltersForm.setCollectionFilterButtonsExpanded(false);
			FacetFiltersForm.syncCollectionFilterBodyState();
		}

		static toggleActiveFacets(disable = true) {
		document.querySelectorAll(".js-facet-remove").forEach((element) => {
			element.classList.toggle("disabled", disable);
		});
	}

	static renderLoadingState() {
		const gridContainer = document.getElementById("ProductGridContainer");
		if (!gridContainer) return;

		const collection = gridContainer.querySelector(".collection");
		const productList = gridContainer.querySelector(".product-list");
		if (collection) collection.classList.add("loading", "is-filter-loading");
		if (!productList || productList.dataset.filterGhostActive === "true") return;

		const currentCards = productList.querySelectorAll(".pv2-card, .product-card");
		const ghostCount = Math.min(Math.max(currentCards.length || 8, 4), 8);

		FacetFiltersForm.previousProductListHTML = productList.innerHTML;
		productList.dataset.filterGhostActive = "true";
		productList.setAttribute("aria-busy", "true");
		productList.innerHTML = Array.from({ length: ghostCount }, () => `
			<div class="pv2-card pv2-filter-ghost" aria-hidden="true">
				<div class="pv2-filter-ghost__media"></div>
				<div class="pv2-filter-ghost__info">
					<span class="pv2-filter-ghost__line pv2-filter-ghost__line--small"></span>
					<span class="pv2-filter-ghost__line pv2-filter-ghost__line--title"></span>
					<span class="pv2-filter-ghost__line pv2-filter-ghost__line--meta"></span>
					<span class="pv2-filter-ghost__line pv2-filter-ghost__line--price"></span>
				</div>
			</div>
		`).join("");
	}

	static clearLoadingState() {
		const gridContainer = document.getElementById("ProductGridContainer");
		const collection = gridContainer ? gridContainer.querySelector(".collection") : null;
		const productList = gridContainer ? gridContainer.querySelector(".product-list") : null;

		if (collection) collection.classList.remove("loading", "is-filter-loading");
		if (productList) {
			productList.removeAttribute("aria-busy");
			delete productList.dataset.filterGhostActive;
		}

		delete FacetFiltersForm.previousProductListHTML;
	}

	static restorePreviousGrid() {
		const gridContainer = document.getElementById("ProductGridContainer");
		const productList = gridContainer ? gridContainer.querySelector(".product-list") : null;

		if (productList && FacetFiltersForm.previousProductListHTML) {
			productList.innerHTML = FacetFiltersForm.previousProductListHTML;
		}

		FacetFiltersForm.clearLoadingState();
	}

	static renderPage(searchParams, event, updateURLHash = true) {
		FacetFiltersForm.searchParamsPrev = searchParams;
		const sections = FacetFiltersForm.getSections();
		if (!sections.length) {
			console.warn("Facet filters could not find a collection section to render.");
			FacetFiltersForm.clearLoadingState();
			return;
		}

		const countContainer = document.getElementById("ProductCount");
		const countContainerDesktop = document.getElementById(
			"ProductCountDesktop"
		);
		FacetFiltersForm.renderLoadingState();
		if (countContainer) {
			countContainer.classList.add("loading");
		}
		if (countContainerDesktop) {
			countContainerDesktop.classList.add("loading");
		}

		sections.forEach((section) => {
			const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
			const filterDataUrl = (element) => element.url === url;

			FacetFiltersForm.filterData.some(filterDataUrl)
				? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
				: FacetFiltersForm.renderSectionFromFetch(url, event);
		});

		if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
	}

	static fetchSection(url) {
		if (window.fetch) {
			return window.fetch(url, {
				headers: { "X-Requested-With": "XMLHttpRequest" },
			}).then((response) => {
				if (!response.ok) {
					throw new Error(`Facet request failed with status ${response.status}`);
				}

				return response.text();
			});
		}

		return new Promise((resolve, reject) => {
			const request = new XMLHttpRequest();
			request.open("GET", url, true);
			request.onload = () => {
				if (request.status >= 200 && request.status < 300) {
					resolve(request.responseText);
					return;
				}

				reject(new Error(`Facet request failed with status ${request.status}`));
			};
			request.onerror = () => reject(new Error("Facet request failed"));
			request.send();
		});
	}

	static renderSectionFromFetch(url, event) {
		FacetFiltersForm.fetchSection(url)
			.then((responseText) => {
				const html = responseText;
				FacetFiltersForm.filterData = [
					...FacetFiltersForm.filterData,
					{ html, url },
				];
				FacetFiltersForm.renderProductGridContainer(html);
				FacetFiltersForm.renderSupplementarySectionHTML(html, event);
			})
			.catch((error) => {
				console.error("Facet section fetch failed:", error);
				FacetFiltersForm.restorePreviousGrid();
			});
	}

	static renderSectionFromCache(filterDataUrl, event) {
		try {
			const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
			FacetFiltersForm.renderProductGridContainer(html);
			FacetFiltersForm.renderSupplementarySectionHTML(html, event);
		} catch (error) {
			console.error("Cached facet section render failed:", error);
			FacetFiltersForm.restorePreviousGrid();
		}
	}

	static renderSupplementarySectionHTML(html, event) {
		try {
			FacetFiltersForm.renderFilters(html, event);
		} catch (error) {
			console.warn("Facet controls could not be refreshed:", error);
		}

		try {
			FacetFiltersForm.renderProductCount(html);
		} catch (error) {
			console.warn("Facet product count could not be refreshed:", error);
		}

		if (typeof Swiper !== "function") return;

		document.querySelectorAll(".product-card-js").forEach((slider) => {
			new Swiper(slider, {
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: ".product-button-group .swiper-button-next",
					prevEl: ".product-button-group .swiper-button-prev",
				},
				allowTouchMove: true,
				990: {
					allowTouchMove: false,
				},
			});
		});
	}

	static renderProductGridContainer(html) {
		const productGridContainer = document.getElementById("ProductGridContainer");
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");
		const nextProductGridContainer = parsedHTML.getElementById("ProductGridContainer");
		if (!productGridContainer || !nextProductGridContainer) {
			throw new Error("Filtered section did not include ProductGridContainer");
		}

		productGridContainer.innerHTML = nextProductGridContainer.innerHTML;
		FacetFiltersForm.clearLoadingState();

		if (
			typeof loadMore === "function" &&
			(document.querySelector(".js-load-more") ||
				document.querySelector(".js-infinite-scroll"))
		)
			loadMore();

		if (typeof colorSwatches === "function") colorSwatches();

			if (window.Alpine && typeof window.Alpine.initTree === "function") {
				window.Alpine.initTree(productGridContainer);
			}

			FacetFiltersForm.resetCollectionFilterDrawerState(productGridContainer);
		}

	static renderProductCount(html) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");
		const nextCount = parsedHTML.getElementById("ProductCount");
		const container = document.getElementById("ProductCount");
		const containerDesktop = document.getElementById("ProductCountDesktop");
		if (!nextCount || !container) return;

		container.innerHTML = nextCount.innerHTML;
		container.classList.remove("loading");
		if (containerDesktop) {
			containerDesktop.innerHTML = nextCount.innerHTML;
			containerDesktop.classList.remove("loading");
		}
	}

	static renderFilters(html, event) {
		const parsedHTML = new DOMParser().parseFromString(html, "text/html");

		const facetDetailsElements = parsedHTML.querySelectorAll(
			"#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"
		);
		const matchesIndex = (element) => {
			const jsFilter = event ? event.target.closest(".js-filter") : undefined;
			return jsFilter
				? element.dataset.index === jsFilter.dataset.index
				: false;
		};
		const facetsToRender = Array.from(facetDetailsElements).filter(
			(element) => !matchesIndex(element)
		);
		const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

		facetsToRender.forEach((element) => {
			const target = document.querySelector(
				`.js-filter[data-index="${element.dataset.index}"]`
			);
			if (target) target.innerHTML = element.innerHTML;
		});

		FacetFiltersForm.renderActiveFacets(parsedHTML);
		FacetFiltersForm.renderAdditionalElements(parsedHTML);

		if (countsToRender && event && event.target && event.target.closest)
			FacetFiltersForm.renderCounts(
				countsToRender,
				event.target.closest(".js-filter")
			);

		const checkboxes = document.querySelectorAll(
			'#FacetFiltersFormMobile .js-filter input[type="checkbox"]'
		);
		const removebtn = document.querySelector(
			"#FacetFiltersFormMobile .facets-tag-wrapper"
		);
		const allChecked = Array.from(checkboxes).some(
			(checkbox) => checkbox.checked
		);

			if (removebtn) {
				if (allChecked) {
					removebtn.classList.remove("active");
				} else {
					removebtn.classList.add("active");
				}
			}

			FacetFiltersForm.resetCollectionFilterDrawerState(document);
		}

	static renderActiveFacets(html) {
		const activeFacetElementSelectors = [
			".active-facets-mobile",
			".active-facets-desktop",
		];

		activeFacetElementSelectors.forEach((selector) => {
			const activeFacetsElement = html.querySelector(selector);
			const currentActiveFacetsElement = document.querySelector(selector);
			if (!activeFacetsElement || !currentActiveFacetsElement) return;
			currentActiveFacetsElement.innerHTML = activeFacetsElement.innerHTML;
		});

		FacetFiltersForm.toggleActiveFacets(false);
	}

	static renderAdditionalElements(html) {
		const mobileElementSelectors = [
			".mobile-facets__open",
			".mobile-facets__count",
			".sorting",
		];

		mobileElementSelectors.forEach((selector) => {
			const nextElement = html.querySelector(selector);
			const currentElement = document.querySelector(selector);
			if (!nextElement || !currentElement) return;
			currentElement.innerHTML = nextElement.innerHTML;
		});
	}

	static renderCounts(source, target) {
		const targetElement = target.querySelector(".facets__selected");
		const sourceElement = source.querySelector(".facets__selected");

		const targetElementAccessibility = target.querySelector(".facets__summary");
		const sourceElementAccessibility = source.querySelector(".facets__summary");

		if (sourceElement && targetElement) {
			target.querySelector(".facets__selected").outerHTML =
				source.querySelector(".facets__selected").outerHTML;
		}

		if (targetElementAccessibility && sourceElementAccessibility) {
			target.querySelector(".facets__summary").outerHTML =
				source.querySelector(".facets__summary").outerHTML;
		}
	}

	static updateURLHash(searchParams) {
		history.pushState(
			{ searchParams },
			"",
			`${window.location.pathname}${searchParams && "?".concat(searchParams)}`
		);
	}

	static getSections() {
		const productGrid = document.getElementById("product-grid");
		if (productGrid && productGrid.dataset.id) {
			return [
				{
					section: productGrid.dataset.id,
				},
			];
		}

		const gridContainer = document.getElementById("ProductGridContainer");
		const sectionElement = gridContainer
			? gridContainer.closest(".shopify-section[id^='shopify-section-']")
			: null;
		if (sectionElement) {
			const section = sectionElement.id.replace("shopify-section-", "");
			if (section) return [{ section }];
		}

		const productList = gridContainer
			? gridContainer.querySelector("product-list[id^='product-list-']")
			: null;
		if (productList) {
			const section = productList.id.replace("product-list-", "");
			if (section) return [{ section }];
		}

		const collectionSection = document.querySelector(
			".section-product-grid[id^='shopify-section-']"
		);
		if (collectionSection) {
			const section = collectionSection.id.replace("shopify-section-", "");
			if (section) return [{ section }];
		}

		return [];
	}

	static createSearchParams(form) {
		const formData = new FormData(form);
		const searchParams = new URLSearchParams(formData);
		const currentParams = new URLSearchParams(window.location.search);

		["preview_theme_id", "pb"].forEach((key) => {
			const value = currentParams.get(key);
			if (value && !searchParams.has(key)) searchParams.set(key, value);
		});

		searchParams.delete("page");

		return searchParams.toString();
	}

	static onFilterFormChange(event, targetForm) {
		if (event.__facetFiltersHandled) return;
		event.__facetFiltersHandled = true;
		event.preventDefault();
		event.stopPropagation();
		if (typeof event.stopImmediatePropagation === "function") {
			event.stopImmediatePropagation();
		}
		if (!targetForm) return;

		const sortFilterForms = document.querySelectorAll(
			"#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm, #FacetSortDrawerForm"
		);
		const isMobileFacetCheckbox =
			event.target.classList &&
			event.target.classList.contains("mobile-facets__checkbox");

		if (isMobileFacetCheckbox) {
			FacetFiltersForm.renderPage(
				FacetFiltersForm.createSearchParams(targetForm),
				event
			);
			return;
		}

		const forms = [];
		const isMobile = targetForm.id === "FacetFiltersFormMobile";

		sortFilterForms.forEach((form) => {
			if (!isMobile) {
				if (
					form.id === "FacetSortForm" ||
					form.id === "FacetFiltersForm" ||
					form.id === "FacetSortDrawerForm"
				) {
					const noJsElements = document.querySelectorAll(".no-js-list");
					noJsElements.forEach((el) => el.remove());
					forms.push(FacetFiltersForm.createSearchParams(form));
				}
			} else if (form.id === "FacetFiltersFormMobile") {
				forms.push(FacetFiltersForm.createSearchParams(form));
			}
		});

		FacetFiltersForm.renderPage(forms.filter(Boolean).join("&"), event);
	}

	createSearchParams(form) {
		return FacetFiltersForm.createSearchParams(form);
	}

	onSubmitForm(searchParams, event) {
		FacetFiltersForm.renderPage(searchParams, event);
	}

	onSubmitHandler(event) {
		const targetForm = event.target.closest("form");
		FacetFiltersForm.onFilterFormChange(event, targetForm);
	}

	onActiveFilterClick(event) {
		event.preventDefault();
		event.stopPropagation();
		if (typeof event.stopImmediatePropagation === "function") {
			event.stopImmediatePropagation();
		}
		FacetFiltersForm.toggleActiveFacets();
		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf("?") + 1
				  );
		FacetFiltersForm.renderPage(url);

		// const checkboxes = document.querySelectorAll('#FacetFiltersFormMobile .js-filter input[type="checkbox"]');
		const removebtn = document.querySelector(
			"#FacetFiltersFormMobile .facets-tag-wrapper"
		);
		// const allChecked = Array.from(checkboxes).every(checkbox => !checkbox.checked);
		if (removebtn) removebtn.classList.add("active");

		// if (allChecked) {
		// 	console.log("All checkboxes are checked.");
		// } else {
		// 	console.log("Not all checkboxes are checked.");
		// }
	}
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.delegatedChangeListenerAdded = false;
window.FacetFiltersForm = FacetFiltersForm;
if (
	window.customElements &&
	window.customElements.define &&
	!window.customElements.get("facet-filters-form")
) {
	window.customElements.define("facet-filters-form", FacetFiltersForm);
}
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
	constructor() {
		super();
		this.querySelectorAll("input").forEach((element) =>
			element.addEventListener("change", this.onRangeChange.bind(this))
		);
		this.setMinAndMaxValues();
		this.controlSlider();
		this.controlInput();
	}

	onRangeChange(event) {
		this.adjustToValidValues(event.currentTarget);
		this.setMinAndMaxValues();
	}

	setMinAndMaxValues() {
		const inputs = this.querySelectorAll("input");
		const minInput = inputs[0];
		const maxInput = inputs[1];
		if (maxInput.value) minInput.setAttribute("max", maxInput.value);
		if (minInput.value) maxInput.setAttribute("min", minInput.value);
		if (minInput.value === "") maxInput.setAttribute("min", 0);
		if (maxInput.value === "")
			minInput.setAttribute("max", maxInput.getAttribute("max"));
	}

	adjustToValidValues(input) {
		const value = Number(input.value);
		const min = Number(input.getAttribute("min"));
		const max = Number(input.getAttribute("max"));

		if (value < min) input.value = min;
		if (value > max) input.value = max;
	}

	fillSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		inputRangeWrappers.forEach((inputWrapper) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];

			const range = inputRangeTo.max - inputRangeTo.min;
			const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
			const toCurrent = inputRangeTo.value - inputRangeTo.min;
			const minRange = (fromCurrent / range) * 100;
			const maxRange = (toCurrent / range) * 100;

			inputWrapper.setAttribute(
				"style",
				`--range-min: ${minRange}%; --range-max: ${maxRange}%`
			);
		});
	}

	controlSlider() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputRangeWrappers.forEach((inputWrapper, index) => {
			const inputsRange = inputWrapper.querySelectorAll(".field__range");
			const inputRangeFrom = inputsRange[0];
			const inputRangeTo = inputsRange[1];
			const inputNumberFrom =
				inputNumberWrappers[index].querySelectorAll(".field__input")[0];
			const inputNumberTo =
				inputNumberWrappers[index].querySelectorAll(".field__input")[1];

			inputRangeFrom.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);
				if (from > to) {
					inputRangeFrom.value = to;
					inputNumberFrom.value = to;
				} else {
					inputNumberFrom.value = from;
				}

				this.fillSlider();
			};

			if (Number(inputRangeTo.value) <= 0) {
				inputRangeTo.style.zIndex = 2;
			} else {
				inputRangeTo.style.zIndex = 0;
			}

			inputRangeTo.oninput = () => {
				const from = parseInt(inputRangeFrom.value, 10);
				const to = parseInt(inputRangeTo.value, 10);
				if (from <= to) {
					inputRangeTo.value = to;
					inputNumberTo.value = to;
				} else {
					inputNumberTo.value = from;
					inputRangeTo.value = from;
				}

				if (Number(inputRangeTo.value) <= 0) {
					inputRangeTo.style.zIndex = 2;
				} else {
					inputRangeTo.style.zIndex = 0;
				}

				this.fillSlider();
			};
		});
	}

	controlInput() {
		const inputRangeWrappers = document.querySelectorAll(
			".facets__price .facets__range"
		);
		const inputNumberWrappers = document.querySelectorAll(
			".facets__price .facets__price-wrapper"
		);

		inputNumberWrappers.forEach((inputWrapper, index) => {
			const inputsNumber = inputWrapper.querySelectorAll(".field__input");
			const inputNumberFrom = inputsNumber[0];
			const inputNumberTo = inputsNumber[1];
			const inputRangeFrom =
				inputRangeWrappers[index].querySelectorAll(".field__range")[0];
			const inputRangeTo =
				inputRangeWrappers[index].querySelectorAll(".field__range")[1];

			inputNumberFrom.oninput = () => {
				const from = parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);
				if (from > to) {
					inputRangeFrom.value = to;
					inputNumberFrom.value = to;
				} else {
					inputRangeFrom.value = from;
				}

				this.fillSlider();
			};

			inputNumberTo.oninput = () => {
				const from = parseInt(inputNumberFrom.value, 10);
				const to = parseInt(inputNumberTo.value, 10);
				if (from <= to) {
					inputRangeTo.value = to;
					inputNumberTo.value = to;
				} else {
					inputNumberTo.value = from;
				}

				this.fillSlider();
			};
		});
	}
}

if (
	window.customElements &&
	window.customElements.define &&
	!window.customElements.get("price-range")
) {
	window.customElements.define("price-range", PriceRange);
}

class FacetRemove extends HTMLElement {
	constructor() {
		super();
		const facetLink = this.querySelector("a");
		if (!facetLink) return;
		facetLink.setAttribute("role", "button");
		facetLink.addEventListener("click", this.closeFilter.bind(this));
		facetLink.addEventListener("keyup", (event) => {
			event.preventDefault();
			if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
		});
	}

	closeFilter(event) {
		event.preventDefault();
		event.stopPropagation();
		if (typeof event.stopImmediatePropagation === "function") {
			event.stopImmediatePropagation();
		}
		const form =
			this.closest("facet-filters-form") ||
			document.querySelector("facet-filters-form");
		if (form && typeof form.onActiveFilterClick === "function") {
			form.onActiveFilterClick(event);
			return;
		}

		const url =
			event.currentTarget.href.indexOf("?") == -1
				? ""
				: event.currentTarget.href.slice(
						event.currentTarget.href.indexOf("?") + 1
				  );
		FacetFiltersForm.renderPage(url);
	}
}

if (
	window.customElements &&
	window.customElements.define &&
	!window.customElements.get("facet-remove")
) {
	window.customElements.define("facet-remove", FacetRemove);
}
